<template>
	<v-card class="elevation-0 partners-page partners-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null" class="d-flex">
			<v-skeleton-loader
				v-if="boothStaffLoading"
				v-bind="attrs"
				max-width="555"
				width="100%"
				type="list-item, list-item-three-line, card-heading"
			>
			</v-skeleton-loader>

			<div v-else style="width: 100%">
        <FilterChipButtons
            class="mb-5"
            :isButtonActive="isButtonActive"
            :chipsList="chipsList"
            :clearFilter="clearFilter"
            @handleChipClick="handleChipClick"
        />

        <div v-if="filterModalIsVisible">
          <FilterModal
              :filterModalIsVisible="filterModalIsVisible"
              :currentModalFilter="currentModalFilter"
              :currentModalLabel="currentModalLabel"
              :selectedChips="selectedChips"
              :filters="filters"
              :dateError="date.error"
              :dateOption="date.option"
              :dateRange="date.selectedRange"
              @closeModal="closeModal"
              @applySelection="applySelection"
              @setItem="setItem"
          />
        </div>
				<div class="boothStaff">
					<div v-for="(boothStaff, index) in boothStaffList" :key="index">
						<router-link
							:to="{
								name: isCurrentUser(boothStaff.user_id) ? 'profile' : 'user-by-id',
								params: isCurrentUser(boothStaff.user_id)
									? []
									: { id: boothStaff.user_id },
							}"
							class="text-decoration-none"
							@click.native="handleUserClick(boothStaff)"
						>
							<BoothStaffCard :boothStaff="boothStaff" backgroundColor="#fff" />
						</router-link>
					</div>
				</div>

				<div
					v-if="!boothStaffLoading && boothStaffList.length > 0"
					class="d-flex my-9 justify-center home-page__pagination"
				>
					<Pagination
						:page="filters.page"
						:pageCount="+this.pageCountBoothStaff"
						v-on:pageChange="onPageChange"
					/>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import ButtonBack from '@/components/ButtonBack'
import Block from '@/mixins/Block.js'
import Filter from '@/mixins/Filter'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'
import BoothStaffCard from '@/components/Event/BoothStaffCard.vue'
import Dwh from '@/mixins/Dwh'
import FilterChipButtons from "@/components/FilterChipButtons.vue";

export default {
	name: 'BoothStaffPage',
	mixins: [Block, Filter, Dwh],
	components: {
    FilterChipButtons,
		BoothStaffCard,
		FilterModal,
		FilterChipButton,
		PageBlocked,
		Pagination,
		ButtonBack,
	},

	methods: {
		...mapActions('event', ['getBoothStaff']),
		...mapActions('app', ['setPageTitle']),
		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}

			const { user_id: currentUserId } = this.profile
			return userId === currentUserId
		},
		handleUserClick(user) {
			this.sendTrigger({
				category: 'Event',
				action: 'click_booth_staff',
				module: 'Exhibitor Booth',
				data: user,
			})
		},
	},
	mounted() {
		this.setPageTitle('Booth Staff')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.getBoothStaff(this.requestQuery)
		}
	},

	computed: {
		...mapGetters('event', ['boothStaffLoading', 'boothStaffList', 'pageCountBoothStaff']),
		...mapGetters('auth', ['profile']),
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
			pageBlockedName: 'events',
		}
	},
}
</script>

<style lang="scss"></style>
